import { Budget, BudgetSummary } from "./types";

export const mockSummary: BudgetSummary = {
  enviados: 10,
  alterados: 2,
  contraproposta: 1,
  aceito: 21,
  recusado: 3,
  concluido: 10,
};

export const mockBudgets: Budget[] = [
  {
    id: "1",
    budgetNumber: "#00000",
    recipient: "Volks|total",
    date: "10/10/24 - 20:00",
    version: "v 1.0",
    status: "aceito",
    column: "pendente",
    chassis: "9535E6TB2TR002626",
  },
  {
    id: "2",
    budgetNumber: "#00000",
    recipient: "Consultor da concessionária",
    date: "10/10/24 - 20:00",
    version: "v 1.0",
    status: "contraproposta",
    column: "pendente",
    chassis: "953658268NR010074",
  },
  {
    id: "3",
    budgetNumber: "#00003",
    recipient: "Volks|total",
    date: "13/10/24 - 16:45",
    version: "v 2.0",
    status: "alterado",
    column: "pendente",
    chassis: "9535E6TB2TR002628",
  },
  {
    id: "4",
    budgetNumber: "#00001",
    recipient: "Volks|total",
    date: "11/10/24 - 14:30",
    version: "v 1.0",
    status: "enviado",
    column: "enviado",
    chassis: "9535E6TB2TR002627",
  },
  {
    id: "5",
    budgetNumber: "#00002",
    recipient: "Consultor da concessionária",
    date: "12/10/24 - 09:15",
    version: "v 1.0",
    status: "aceito",
    column: "concluido",
    chassis: "953658268NR010075",
  },
];
